import Reports from './Reports.vue';

export default Reports;
